import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";
import {PcBox as DefaultPcBox, MobileBox as DefaultMobileBox} from "./header-navbar-container.default.box";

const PcBox = styled(DefaultPcBox)`
  position: absolute;
  width: 100%;
  background: linear-gradient(#000000 35%, transparent);
`;

const MobileBox = styled(DefaultMobileBox)`
  border-bottom: none;
`;

export const HeaderNavbarContainerWsopBox = styledByDevice(PcBox, MobileBox);
